import { ReduxService } from 'dashboard-services/services'

import groupDialogDatalakeActions from 'actions/modules/datalake/groupDialog'

export const groupDialogInitialState = {
  isOpen: false,
  mode: undefined,
  tab: undefined,
  groupName: undefined,
  description: undefined,
  fields: undefined,
  groupTags: undefined,
  owner: undefined,
  canBeShared: false
}

export default (state = groupDialogInitialState, action) => {
  switch (action.type) {
    case groupDialogDatalakeActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state
    }
    case groupDialogDatalakeActions.RESET:
      return groupDialogInitialState
    default:
      return state
  }
}
